module.exports = __webpack_public_path__ + "media/images/arrows/twisted/green-left-fc2bebcacbb79a4852ff3e491f4389b8.svg";